import dotenv from 'dotenv';

dotenv.config();

export const API_URL = process.env.REACT_APP_API_URL;
export const REACT_APP_GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;
